import React from 'react'
import { Link } from "react-router-dom";


const HomeAbout = () => {
    return (
        <>

            <section className="about-section section-padding fix">
                <div className="tubelight-shape">
                    <img src="assets/img/about/tubelight.png" alt="shape-img" />
                </div>
                <div className="sun-shape float-bob-y">
                    <img src="assets/img/about/sun.png" alt="shape-img" />
                </div>
                <div className="star-shape">
                    <img src="assets/img/about/star.png" alt="shape-img" />
                </div>
                <div className="love-shape float-bob-x">
                    <img src="assets/img/about/love.png" alt="shape-img" />
                </div>
                <div className="frame-shape">
                    <img src="assets/img/about/frame.png" alt="shape-img" />
                </div>
                <div className="container">
                    <div className="about-wrapper">
                        <div className="row g-4 align-items-center">
                            <div className="col-lg-6">
                                <div className="about-image-box">
                                    <div className="about-image">
                                        <img src="assets/img/about/about-1.png" alt="about-image" className="wow fadeInUp" data-wow-delay=".5s" />
                                        <div className="shape-bg wow zoomIn" data-wow-delay=".5s">
                                            <img src="assets/img/about/about-bg-1.png" alt="shape-image" />
                                        </div>
                                    </div>
                                    <div className="counter-image float-bob-x">
                                        <img src="assets/img/about/ab-counter.png" alt="shape-img" />
                                        <div className="counter-box">
                                            <div className="count">
                                                <h2 className="odometer" data-count={21}>0</h2>
                                                <span className="plus">+</span>
                                            </div>
                                            <p>Experience</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="about-content">
                                    <div className="section-title text-left">
                                        <span className="sub-title wow fadeInUp text-left">About Us</span>
                                        <h2 className="char-animation">
                                            Safe, Fun &amp; <span>Educational</span> – Just What Your Child Needs
                                        </h2>
                                    </div>
                                    <div className="content-bottom mt-4 mt-md-0">
                                        <p className="wow fadeInUp" data-wow-delay=".7s" style={{textAlign:"justify"}}>
                                            Sudarshan Academy is a dedicated educational institute committed to nurturing young minds and shaping a brighter future through quality education. With a strong focus on academic excellence, discipline, and holistic development, we aim to empower students with the knowledge and skills they need to succeed in today’s competitive world.

                                            At Sudarshan Academy, we believe that every student has unique potential. Our experienced and passionate faculty members provide personalized attention to ensure each student achieves their best. We combine modern teaching methods with a strong foundation of core concepts to create an engaging and effective learning environment.
                                        </p>
                                        {/* <div className="about-list wow fadeInUp" data-wow-delay=".8s">
                                            <ul>
                                                <li className="mb-3"><i className="fas fa-check" /> Learning &amp; Fun</li>
                                                <li><i className="fas fa-check" /> Children Safety</li>
                                            </ul>
                                            <ul>
                                                <li className="mb-3"><i className="fas fa-check" /> Healthy Meals</li>
                                                <li><i className="fas fa-check" /> Cute Environment</li>
                                            </ul>
                                        </div> */}
                                        <div className="about-button wow fadeInUp" data-wow-delay=".9s">
                                            <Link to="/about-us" className="theme-btn">Explore More <i className="icon-arrow-icon" /></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default HomeAbout